import PopupSettings from "./components/PopupSettings";

export default PopupSettings;
